import React from "react";
import Marty from "marty";
import IV from "./components/ImageViewer";
import Pulse from "./components/TechPulse";
import assign from "object-assign";
import Hero from "../components/Hero";
import Embed from "../components/FluidEmbed";
import { Link } from "react-router";
import BuyButton from "../../../components/BuyButton";
import { Modal } from "react-bootstrap";
import TrueMeshAnimation from "./components/TrueMeshAnimation";


const underHoodImages = [
    {
        url: "/public/img/technology/product-shots/top-large.png",
        thumbUrl: "/public/img/technology/product-shots/top-thumb.png",
        label: "Top"
    },
    {
        url: "/public/img/technology/product-shots/back-large.png",
        thumbUrl: "/public/img/technology/product-shots/back-thumb.png",
        label: "Back"
    },
    {
        url: "/public/img/technology/product-shots/front-large.png",
        thumbUrl: "/public/img/technology/product-shots/front-thumb.png",
        label: "Front"
    },
    {
        url: "/public/img/technology/product-shots/bottom-large.png",
        thumbUrl: "/public/img/technology/product-shots/bottom-thumb.png",
        label: "Bottom"
    }
];

let Technology = React.createClass({
    handleSectionClick(id) {
        this.setState({
            current: id,
            last: this.state.current,
            open: {}
        });
    },
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Technology";
        }
    },
    handleExpanderClick(name) {
        this.setState({
            open: assign(this.state.open, {[name]: !this.state.open[name]})
        });
    },
    closeModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: false}
            )
        });
    },
    mailingList() {
        this.app.navStore.showMailingListModal();
    },
    openModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: true}
            )
        });
    },
    render() {

        return (
            <section className="eo-view technology grid-10 parent">
                <Hero>
                    <h1>The only WiFi system <br/>with TrueMesh</h1>
                </Hero>

                <div className="eo-padded-wrapper grid-10">
                    <section className="grid-10 distributed-system parent eo-section eo-info-panel dark eo-centered">
                        <h2 className="eo-info-panel-header">You need multiple access points</h2>

                        <p className="eo-info-panel-copy">
                            Distance may be good for the heart, but it weakens WiFi signal. Same goes for walls, appliances, neighbors’ networks, metal, water heaters, anything solid. In a nutshell, modern WiFi uses two frequencies to transmit data: 5 GHz waves (the new 802.11ac standard) that are able to transmit more data, but are limited to shorter distances; and 2.4 GHz waves (the older 802.11n standard) that transmit less data but are able to travel farther distances. So, in order to take advantage of 5 GHz speeds, you need multiple access points — devices that broadcast WiFi — distributed throughout your home, so you’re always close to one.
                        </p>

                        <p className="eo-info-panel-copy">Until now, recreating this sort of setup at home has meant expensive Ethernet wiring, painful manual setup, custom firmware, and an IT person. eero makes this enterprise model simple, elegant, and easy for anyone to manage. Multiple eeros automatically connect to form a wireless mesh network. Unlike the “hub-and-spoke” model of a single router and a range extender, each eero in the network is created equal and the result is an incredibly fast, reliable network.</p>
                    </section>

                    {/* TrueMesh ANIMATION */}
                    <TrueMeshAnimation />
                </div>


                <div className="eo-padded-wrapper grid-10">
                    <section className="grid-10 parent eo-centered mad-hops gradient-bg eo-info-panel">
                        <h2 className="standard">The disappointment of range “extenders”</h2>
                        <p className="eo-info-panel-copy">If you’ve ever tried to give your router a boost with an “extender,” then you’ve experienced true disappointment. That’s because “extenders” can only stretch your signal a single hop — you can’t connect multiple in a row. They often create an entirely separate network (SSID), so you find yourself having to continually switch from one network to the other as you move through your house.  </p>

                        <p className="eo-info-panel-copy">Worse, many range “extenders” cut your bandwidth in half because they rely on a single wireless radio to both send and receive data. In contrast, each eero has two radios — both of which communicate with your devices and sync with other eeros — so your connection is always fast. And with TrueMesh, eero supports multiple hops, making it possible to cover a home of any shape or size. Not only does an eero system operate on a single network name (SSID), but you can also walk throughout your home and devices like your iPhone will connect to the nearest eero.</p>
                        <img src="/public/img/technology/graph02.png" className="eo-img-fluid graph hide-s"/>
                        <a href="https://blog.eero.com/save-yourself-the-hassle-why-range-extenders-just-dont-work-e778e0e333a3#.98ydapv63" target="_blank" className="extender-link eo-link">Why do range extenders underperform?<span className="icon eo-icon-arrow-right"></span></a>
                    </section>
                    <section className="under-the-hood eo-section grid-10 parent eo-info-panel gradient-bg eo-centered">
                        <h2 className="eo-info-panel-header under-the-hood-header">Under the hood</h2>

                        <div className="eo-text-group">
                            <p className="under-the-hood-copy eo-info-panel-copy">We designed eero with an incredible attention to detail. It’s engineered from the ground up to achieve the best performance with the smallest footprint possible. That means fitting a powerful dual-core 1 GHz CPU, two state-of-the-art 802.11ac WiFi radios, and 5 antennas into a beautiful enclosure that you can hold in the palm of your hand.</p>
                        </div>
                        <IV className="under-the-hood-image-viewer" data={underHoodImages}></IV>
                    </section>
                    <section className="grid-10 parent eo-section eo-info-panel eo-centered tech-specs">
                        <h2 className="eo-info-panel-header">Tech specs</h2>
                        <p className="eo-info-panel-copy">Want to get into the technical nitty gritty?</p>

                        <div className="spec-table grid-10 parent">
                            <div className="grid-10 spec-table-row">
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Dimensions</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">Width: 4.75in (121mm)</p>

                                        <p className="spec-table-copy">Depth: 4.75in (121mm)</p>

                                        <p className="spec-table-copy">Height: 1.34in (34mm)</p>
                                    </div>
                                </div>
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Security and networking services</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">WPA2 personal wireless encryption,</p>

                                        <p className="spec-table-copy">DHCP, NAT, VPN passthrough, UPnP, Static IP, and Port Forwarding.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="grid-10 spec-table-row">
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Processor, memory, and storage</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">1.0 GHz dual-core processor
                                            <p className="spec-table-copy">512MB RAM</p>
                                            <p className="spec-table-copy">4GB flash storage</p></p>

                                    </div>
                                </div>
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Electrical and environmental requirements</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">100-240V AC, 50-60Hz, operating temperature: 32° to 95° F (0° to 35° C), operating relative humidity: 20% to 80%
                                            (non-condensing)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="grid-10 spec-table-row">
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Wireless connectivity</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">Dual-band WiFi radios, simultaneous 2.4 GHz and 5 GHz wireless, 2x2 MIMO, IEEE 802.11a/b/g/n/ac, Bluetooth® Smart Ready</p>
                                    </div>
                                </div>
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Required for setup</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">
                                            Supported iOS or Android™ device with data connection. See <Link
                                            to="app" className="eo-link">eero.com/app</Link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="grid-10 spec-table-row">
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Wired connectivity</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">Dual auto-sensing Gigabit ports for WAN (cable or DSL modem) and/or LAN (networked device) connectivity, USB 2.0 port</p>
                                    </div>
                                </div>
                                <div className="spec-table-col grid-5 grid-s-10">
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-title">Warranty</p>
                                    </div>
                                    <div className="spec-table-cell grid-5 grid-s-10 parent">
                                        <p className="spec-table-copy">1-year limited warranty. See <Link className="eo-link" to="warranty">eero.com/legal/warranty</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="grid-10 requirements parent eo-section eo-info-panel dark eo-centered">
                        <h2 className="eo-info-panel-header">Setup Requirements</h2>
                        <p className="eo-info-panel-copy">eero iOS or Android app, Internet service (with cable or DSL modem, if required)</p>
                        <Link to="app" className="eo-btn-outline white hover-blue">See requirements</Link>
                    </section>
                    <section className="grid-10 eo-section eo-cta big-cta hide-s">
                        <div className="eo-cta-content">
                            <h3 className="eo-cta-header"><span className="big-text eo-cta-header-group">BUSINESS<br/>GRADE WIFI</span></h3>
                            <h4>FOR YOUR HOME</h4>
                            <BuyButton/>
                        </div>
                    </section>
                </div>
            </section>
        );
    },
    getInitialState() {
        return {
            current: 0,
            last: 1,
            open: false,
            showModal: {
                video: false
            }
        };
    }
});

export default Marty.createContainer(Technology, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/technology/Handler.js
 **/